var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import Compass03Svg from './compass-03.icon.svg';
export const Compass03Icon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: Compass03Svg }));
_react_refresh_temp_1 = Compass03Icon;
$RefreshReg$(_react_refresh_temp_1, "Compass03Icon");
